import axios from 'axios';

/**
 * Fetches wholesale ship-date picker constraints from the server (single source of truth).
 *
 * @param {Record<string, unknown>} payload
 * @returns {Promise<Record<string, unknown>>}
 */
export async function fetchStaffShipDateConstraints(payload) {
    const { data } = await axios.post(route('ship_date_constraints.staff'), payload);

    return data;
}

/**
 * @param {string} shippingMethod
 * @returns {Promise<Record<string, unknown>>}
 */
export async function fetchCheckoutShipDateConstraints(shippingMethod) {
    const { data } = await axios.post(route('ship_date_constraints.checkout'), {
        shipping_method: shippingMethod,
    });

    return data;
}

/**
 * @param {number|string} orderId
 * @param {Record<string, unknown>} payload
 * @returns {Promise<Record<string, unknown>>}
 */
export async function fetchCustomerOrderEditShipDateConstraints(orderId, payload) {
    const { data } = await axios.post(
        route('ship_date_constraints.customer_order_edit', orderId),
        payload
    );

    return data;
}
